<template>
  <div style="height: 100%">
    <div class="inject-home" v-if="homeShow">
      <div>
        <a-select style="width: 100%" @change="handleChange" :placeholder="$t('edit.editMessage.hotPSelect')">
          <a-select-option value="link">{{ $t('edit.hpInfo.link') }}</a-select-option>
          <a-select-option value="pic">{{ $t('edit.hpInfo.picture') }}</a-select-option>
          <a-select-option value="video">{{ $t('edit.hpInfo.video') }}</a-select-option>
          <a-select-option value="word">{{ $t('edit.hpInfo.text') }}</a-select-option>
          <a-select-option value="pictext">{{ $t('edit.hpInfo.imageText') }}</a-select-option>
          <a-select-option value="audio">{{ $t('edit.hpInfo.audio') }}</a-select-option>
        </a-select>
        <div class="list-title">{{ $t('edit.hpInfo.currentHP') }}</div>
      </div>

      <HotspotList v-for="(value, k) in hotspotObj" :key="k" :itemObj="value" :selectedId="currHotId"
        @renameItem="renameItem" @deleteItem="deleteItem" @editItem="editItem" @click.native="onClickItem(value)">
      </HotspotList>
    </div>
    <HotpointPic v-if="picShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointPic>
    <HotpointPicText v-if="pictextShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointPicText>
    <HotpointAudio v-if="audioShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointAudio>
    <HotpointLink v-if="linkShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointLink>
    <!-- <HotpointScene v-if="sceneShow" :defaultValue="editTarget" @clickBack="clickBack" @saveDataToStore="saveDataToStore"></HotpointScene> -->
    <HotpointVideo v-if="videoShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointVideo>
    <HotpointWord v-if="wordShow" :defaultValue="editTarget" @clickBack="clickBack" @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore" @change="handleHotspotChange"></HotpointWord>
    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="handleConfirm">
      <div>
        <div>
          <a-input v-model="newName" :addonBefore="$t('edit.name')" :placeholder="renameObj.title"></a-input>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import HotpointPic from "./HotpointPic";
import HotpointPicText from "./HotpointPicText";
import HotpointAudio from "./HotpointAudio";
import HotpointLink from "./HotpointLink";
import HotpointScene from "./HotpointScene";
import HotpointVideo from "./HotpointVideo";
import HotpointWord from "./HotpointWord";
import HotspotList from "./HotspotList";
import { mapGetters } from "vuex";
import { getAllIcons } from "@/api/work";
// import { v1, v2, v3, v4, v5 } from "uuid";

export default {
  components: {
    HotpointPic,
    HotpointPicText,
    HotpointAudio,
    HotpointLink,
    HotpointScene,
    HotpointVideo,
    HotpointWord,
    HotspotList,
  },
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      sceneShow: false,
      linkShow: false,
      picShow: false,
      pictextShow: false,
      videoShow: false,
      wordShow: false,
      audioShow: false,
      renameVisible: false,
      allHotIcon: [],
      newName: "",
      renameObj: {},
      editTarget: null,
      currHotId: "",
      isAddNew: true,
    };
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId", "userInfo"]) },
  watch: {
    currentScenesId() {
      this.handleInitListData();
    },
  },
  created() {
    this.handleInitListData();
  },
  methods: {
    // 這裡過濾掉scene類型的數據
    handleInitListData() {
      const hotports = this.vrbase.scenes[this.currentScenesId].hotspot;
      // console.log('hotports', hotports);
      let keys = Object.keys(hotports);
      let tempObj = {};
      for (let key in hotports) {
        if (hotports[key].type !== "scene") {
          tempObj[key] = hotports[key];
        }
      }
      this.hotspotObj = tempObj;
    },
    onClickItem(item) {
      // console.log("onClickitem=", item);
      this.currHotId = item.hotspot_id;
      lookto(item.ath, item.atv);
    },
    editItem(itemObj) {
      this.handleChange(itemObj.type, false);
      // console.log(itemObj.type);
      this.editTarget = itemObj;
    },
    handleChange(value, isAddNew = true) {
      this.editTarget = null; // 清空選擇的編輯對像
      this.isAddNew = isAddNew;
      const typeObj = {
        scene: value === "scene",
        link: value === "link",
        pictext: value === "pictext",
        pic: value === "pic",
        video: value === "video",
        word: value === "word",
        audio: value === "audio",
      };
      this.homeShow = value === "home";
      // console.log(value, typeObj.scene);
      this.sceneShow = typeObj.scene;
      this.linkShow = typeObj.link;
      this.pictextShow = typeObj.pictext;
      this.picShow = typeObj.pic;
      this.videoShow = typeObj.video;
      this.wordShow = typeObj.word;
      this.audioShow = typeObj.audio;
    },
    clickBack(hotspot) {
      if (this.isAddNew) {
        removeHotspot(hotspot.hotspot_id);
      }
      this.handleChange("home");
    },
    clickDelete(hotspot) {
      this.deleteItem(hotspot);
      this.handleChange("home");
    },
    saveDataToStore({ key, data }) {
      this.handleChange("home");
      let vrbase = this.vrbase;
      this.$set(this.hotspotObj, key, data); // 更新本地
      vrbase.scenes[this.currentScenesId].hotspot[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      this.$store.dispatch("saveVRBase", { vrbase, showLoading: true });
    },
    renameItem(selectedItem) {
      this.renameObj = selectedItem;
      this.renameVisible = true;
    },
    deleteItem(selectedItem) {
      let hotspot = this.vrbase.scenes[this.currentScenesId].hotspot;
      this.$delete(hotspot, selectedItem.hotspot_id);
      this.$delete(this.hotspotObj, selectedItem.hotspot_id);
      this.$store.dispatch("setVRBase", this.vrbase);
      removeHotspot(selectedItem.hotspot_id);
    },
    handleConfirm() {
      // console.log('3');
      let item = this.vrbase.scenes[this.currentScenesId].hotspot[
        this.renameObj.hotspot_id
      ];
      this.$set(item, "title", this.newName);
      this.$store.dispatch("setVRBase", this.vrbase);
      this.renameVisible = false;
      //更新krpano
      this.handleHotspotChange(this.renameObj, {})
      // reset data
      this.newName = "";
      this.renameObj = {};
    },
    handleHotspotChange(val, oldVal) {
      console.log(
        '觸發handleHotspotChange', 
        '\noldVal:', oldVal,
        '\nval:', val,
      );
      setHotspot(val, oldVal);
    },
  },
};
</script>